import { Component, OnInit, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { GeneralService } from './../../services/admin/general.service';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { IndicadorImpuestosService } from '../../services/indicador-impuestos/indicador-impuestos.service';
import { ProcessInvoicesService } from './../../services/process-invoices/process-invoices.service';
import { User } from '../../models/user';
import { ENPOINT } from './../../services/endpoint';
import { GLOBAL } from './../../services/global';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};


@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}



@Component({
  selector: 'app-processinvoices',
  templateUrl: './process-invoices.component.html',
  styleUrls: ['./process-invoices.component.scss'],
  providers: [GeneralService, CatalogsService, IndicadorImpuestosService, ProcessInvoicesService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class ProcessInvoicesComponent implements OnInit {
  public user: User;
  private basePath;
  private language = localStorage.getItem('LOCAL_STORAGE');              
  url: string;
  rows = [];
  selected = [];
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };

  facturas = [];
  referencia;
  masterFacturas;
  numFacturasProcesadas;
  docPdf;
  docXml;
  docPdfNC;
  docXmlNC;
  salida = {
    masterFactura: []
  };
  flagDescargaZip = false;
  editing = {};
  editClicked = null;
  closeResult: string;
  modalConfirmacion;
  uuidSeleccionado;
  modalFilters;
  masterFacts = [];
  proveedores;
  sociedades;
  mostrarxml = false;
  fechaHoy = '';
  fechaAnterior = '';
  proveedorFilter = '';
  sociedadFilter = '';
  tipoFacturaFilter = '';
  ordenCompraFilter = '';
  referenciaFilter = '';
  neaFilter = '';
  documentoFilter = '';
  pedimentoFilter = '';
  ordenCompraModalFilter = '';
  documentoContable = '';

  tipoFactura = [
    { id: 'SOC', name: 'Financiera' },
    { id: 'OC', name: 'Logística' }
  ];

  expandir: boolean = false;
  proveedores$: Observable<any>;
  proveedoresLoadig = false;
  proveedorinput$ = new Subject<string>();

  sociedades$: Observable<any>;
  sociedadesLoadig = false;
  sociedadinput$ = new Subject<string>();

  busy: boolean = false;
  busyReload: boolean = false;
  busyBusqueda: boolean = false;
  loadingExcel: boolean = false;

  flagBusqueda = false; flagMensaje;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  constructor(private translate: TranslateService,
    private storageService: StorageService,
    private general: GeneralService,
    private catalogs: CatalogsService,
    private indicadoresDeImpuestos: IndicadorImpuestosService,
    private processInvoicesService: ProcessInvoicesService,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.url = GLOBAL.url;
    this.basePath = ENPOINT.url;

    this.getProveedores();
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.modulo();
    this.getSociedades();
    this.getMasterFacturas();
    if (this.language)      
      this.language = this.language.replace(/["']/g, "")
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Contabilizar facturas').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  getTraslatedText(value) {    

    if (this.language === "en") {
      switch (value) {
        case "Pagada Extranjero":
          return "Paid Foreign"          
        case "Cerrado sin complemento":
          return "Closed without complement"                                    
        case "Con complemento":
          return "With complement"          
        case "Pagada":
          return "Paid"          
        case "Parcial con complemento":
          return "Partial with complement"          
        case "Cancelado" || "C":
          return "Cancelled"          
        case "Cerrado con complementos parciales":
          return "Closed with partial complements"          
        case "Programado para pago":
          return "Scheduled for payment"                                  
        case "Factoraje":
          return "Factoring"          
        case "Nota Compensada":
          return "Note compensated"          
        case "En revisión":
          return "In Review"          
        case "Anulada" || "A":
          return "Annuled"          
        case "Procesada":
          return "Processed"          
        default:
          break;
      }
    } else {
      switch (value) {        
        case "C":
          return "Cancelado"                  
        case "A":
          return "Anulado"             
        default:
          return value
      }
    }
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoadig = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoadig = false)
          ))
      )
    );
  }


  getSociedades() {
    this.busy = true;
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.busy = false;
        this.sociedades = data.sapSociedad;
      },
      err => {},
    );
  }


  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    if (this.selected.length > 0) {
      this.flagDescargaZip = true;
    } else {
      this.flagDescargaZip = false;
    }
  }

  toggleExpandRow(row, index) { 
    for (let i = 0; i < this.rows.length; i++) {
      if (String(this.rows[i].ordencompra) == String(row.ordencompra) && this.rows[i].docVim == row.docVim) {
        this.rows[i].indexTmp = index;
        this.rows[i].flagIndicadorImpExt = false;
        this.setIndicadorExt(i, row);
      }
    }
    
    this.table.rowDetail.toggleExpandRow(row);  
    this.editClicked = false;
  }

  setIndicadorExt(index, row) { 
     //REVISAR SI LA FACTURA DE ACUERDO AL UUID REGRSA INFO (SOCIEDAD OKFI EXTRANJEROS)
     this.indicadoresDeImpuestos.getFacturaUUID(row.uuid).subscribe(
      response => {
        if (response.status === 200) {
          this.rows[index].flagIndicadorImpExt = true;
          this.rows[index].indicadorImpuestoExt = response.body['indicadorImpExt'];
        }
      },  
      err => {},
    );
  }


  getMasterFacturas() {
    this.selected = [];
    this.flagDescargaZip = false;
    this.fechaAnterior = null; this.fechaHoy = null;
    this.rows = []; this.masterFacturas = []; this.facturas = [];
    /* Fecha actual */
    var hoy: any = new Date(); 
    var dd: any = hoy.getDate();
    var mm: any = hoy.getMonth() + 1;
    var yyyy = hoy.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    this.fechaHoy = yyyy + '-' + mm + '-' + dd;

    /* Fecha 15 dias antes */
    var dieciseisDias = 1000 * 60 * 60 * 24 * 15;
    var resta = hoy.getTime() - dieciseisDias;
    var fechaAtras = new Date(resta); 

    var ddAtras: any = fechaAtras.getDate();
    var mmAtras: any = fechaAtras.getMonth() + 1;
    var yyyyAtras: any = fechaAtras.getFullYear();

    if (ddAtras < 10) {
      ddAtras = '0' + ddAtras;
    }

    if (mmAtras < 10) {
      mmAtras = '0' + mmAtras;
    }

    this.fechaAnterior = yyyyAtras + '-' + mmAtras + '-' + ddAtras;
    this.sociedadFilter = '';
    this.proveedorFilter = '';
    this.neaFilter = '';
    this.documentoFilter = '';
    this.tipoFacturaFilter = '';
    this.referenciaFilter = '';
    this.ordenCompraFilter = '';
    this.busy = true;
    this.processInvoicesService.obtenerMasterFacturasPro(this.sociedadFilter, this.proveedorFilter, this.fechaHoy,
      this.fechaHoy, this.neaFilter, this.documentoFilter, this.tipoFacturaFilter, this.referenciaFilter, this.ordenCompraFilter,
      this.user.id).subscribe(
        data => {
          this.busy = false;
          if (data != null) {
            this.masterFacturas = data.masterFactura; 
            // this.rows = this.masterFacturas;

            for (let i = 0; i < this.masterFacturas.length; i++) {
              var datosTmp = [];
              if (this.masterFacturas[i].uuidComplementosRelacionados) {
                if (typeof (this.masterFacturas[i].uuidComplementosRelacionados) == 'string') {
                  datosTmp.push(this.masterFacturas[i].uuidComplementosRelacionados);
                } else if (typeof (this.masterFacturas[i].uuidComplementosRelacionados) == 'object') {
                  for (let j = 0; j < this.masterFacturas[i].uuidComplementosRelacionados.length; j++) {
                    datosTmp.push(this.masterFacturas[i].uuidComplementosRelacionados[j]);
                  }
                }
              }

              var datos = {
                aacategory: this.masterFacturas[i].aacategory,
                cabecera: this.masterFacturas[i].cabecera,
                claseDeDocumento: this.masterFacturas[i].claseDeDocumento,
                docVim: this.masterFacturas[i].docVim,
                estatus: this.masterFacturas[i].estatus,
                fechaCarga: this.masterFacturas[i].fechaCarga,
                fechaCont: this.masterFacturas[i].fechaCont,
                fechaFact: this.masterFacturas[i].fechaFact,
                importe: this.masterFacturas[i].importe,
                indicadorIva: this.masterFacturas[i].indicadorIva,
                iva: this.masterFacturas[i].iva,
                moneda: this.masterFacturas[i].moneda,
                nea: this.masterFacturas[i].nea,
                nodocumento: this.masterFacturas[i].nodocumento,
                operacion: this.masterFacturas[i].operacion,
                ordencompra: this.masterFacturas[i].ordencompra,
                paymentblock: this.masterFacturas[i].paymentblock,
                pdf: this.masterFacturas[i].pdf,
                proveedor: this.masterFacturas[i].proveedor,
                referencia: this.masterFacturas[i].referencia,
                requsito: this.masterFacturas[i].requisito,
                sociedad: this.masterFacturas[i].sociedad,
                texto: this.masterFacturas[i].texto,
                textoCabecera: this.masterFacturas[i].textoCabecera,
                tipo: this.masterFacturas[i].tipo,
                uuid: this.masterFacturas[i].uuid,
                uuidComplementosRelacionados: datosTmp,
                xml: this.masterFacturas[i].xml,
                totalNota: this.masterFacturas[i].totalNota,
                uuidNota: this.masterFacturas[i].uuidNota,
                rutaPdfNota: this.masterFacturas[i].rutaPdfNota,
                rutaXmlNota: this.masterFacturas[i].rutaXmlNota,
                rutaZIP: this.masterFacturas[i].zip,
                docContable: this.masterFacturas[i].docContable ? this.masterFacturas[i].docContable : '--',
                cuentaAgente: this.masterFacturas[i].cuentaAgente ? this.masterFacturas[i].cuentaAgente : '--',
                pedimento: this.masterFacturas[i].pedimento ? this.masterFacturas[i].pedimento : '--'
              }
              this.facturas.push(datos);
            }
            this.rows = this.facturas; 

            this.numFacturasProcesadas = this.masterFacturas.length;
            if (this.masterFacturas.length > 0) {
              this.mostrarxml = true;
            } else {
              this.mostrarxml = false;
            }
          }
        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          }
        },
    );
  }



  getXMLReporte() {
    const params = '?sociedad=' + this.sociedadFilter + '&provedor=' + this.proveedorFilter + '&fechai=' + this.fechaAnterior + '&fechaf=' + this.fechaHoy +
      '&nea=' + this.neaFilter + '&nodocumento=' + this.documentoFilter + '&estatus=&grupoimputacion=&tipo=' + this.tipoFacturaFilter + '&referencia=' + this.referenciaFilter +
      '&usuario=' + this.user.id;

    this.loadingExcel = true;

    this.processInvoicesService.downloadExcelReport(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte-facturas-contabilizadas.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error('Error al descargar el reporte:', error);
      },
      () => {
        this.loadingExcel = false;
      }
    );
  }

  descargaPdf(value) {
    this.docPdf = value;
    this.getPdf();
  }

  getPdf() {
    const srcFile = this.docPdf;

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      this.processInvoicesService.downloadPdf(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Factura.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );
    } 
  }

  descargaPdfNC(value) {
    this.docPdfNC = value; 
    this.getPdfNC();
  }

  getPdfNC() {
    const srcFile = this.docPdfNC;

    if (srcFile) {
      const srcB64 = btoa(srcFile);
      
      this.processInvoicesService.downloadPdf(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Nota-credito.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );
    } 
  }

  descargaXml(value) {
    this.docXml = value;
    this.getXml();
  }

  getXml() {
    const srcFile = this.docXml;

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      this.processInvoicesService.downloadXml(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Factura.xml`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el XML:', error);
        }
      );
    }
  }

  descargaXmlNC(value) {
    this.docXmlNC = value;
    this.getXmlNC();
  }

  getXmlNC() {
    const srcFile = this.docXmlNC;

    if (srcFile) {
      const srcB64 = btoa(srcFile);
      
      this.processInvoicesService.downloadXml(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Nota-credito.xml`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el XML:', error);
        }
      );
    }
  }

  getZIP(value) {
    const url = this.basePath + 'master-factura/obtener-zip-agente';

    if (value) {
      const srcB64 = btoa(url);
      const win = window.open(url + '?ruta=' + srcB64, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }
    }
  }

  descargarZip() {
    this.salida.masterFactura = [];

    for (let i = 0; i < this.selected.length; i++) {

      let xmlDoc;
      if (this.selected[i].xml !== '') {
        xmlDoc = this.selected[i].xml;
      } else {
        xmlDoc = '';
      }

      let pdfDoc;
      if (this.selected[i].pdf !== '') {
        pdfDoc = this.selected[i].pdf;
      } else {
        pdfDoc = '';
      }

      const objectFacturas = {
        pdf: pdfDoc,
        xml: xmlDoc
      };

      this.salida.masterFactura.push(objectFacturas);
    }

    this.processInvoicesService.obtenerZip(this.salida).subscribe(
      data => {
        const respuesta = data.result.mensaje;
        const win = window.open('data:application/zip;base64,' + respuesta, '_blank');
        if (win) {
          win.focus();
        } else {
          alert('Por favor activa los popups en tu navegador');
        }
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  btnEditar(row) {
    for (let i = 0; i < this.rows.length; i++) {
      if (String(this.rows[i].ordencompra) == String(row.ordencompra) && this.rows[i].docVim == row.docVim) {
        this.rows[i].editar = true;
      }
    }

    this.editClicked = true;
  }

  btnCancelarEdit(row) {
    for (let i = 0; i < this.rows.length; i++) {
      if (String(this.rows[i].ordencompra) == String(row.ordencompra) && this.rows[i].docVim == row.docVim) {
        this.rows[i].editar = false;
      }
    }
   
    this.editClicked = false;
  }

  guardarEdicion() {
    const estatus = (<HTMLSelectElement>document.getElementById('estatus')).value;

    this.processInvoicesService.cambiarStatus(this.uuidSeleccionado, estatus).subscribe(
      data => {
        this.editClicked = false;
        const mensaje = data.result.message;
        let estado = data.result.status;
        if (estado === 'S') {
          estado = '';
          this.toasterService.pop('success', estado, mensaje);
        } else {
          estado = 'Error';
          this.toasterService.pop('error', estado, mensaje);
        }

        this.masterFacturas = '';
        this.rows = [];
        this.numFacturasProcesadas = '';
        this.getMasterFacturas();

        this.modalConfirmacion.close();
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  openConfirmacion(confirmacion, row) { 
    this.uuidSeleccionado = row.uuid;
    this.modalConfirmacion = this.modalService.open(confirmacion, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalConfirmacion.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilters(filtersCheckInv) {

    this.modalFilters = this.modalService.open(filtersCheckInv, { centered: true });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFilters(reason)}`;
    });
  }

  private getDismissReasonFilters(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  buscarFacturas() {
    this.busyBusqueda = true;
    let proveedor = this.proveedorFilter;
    let sociedad = this.sociedadFilter;
    let ordenCompra = this.ordenCompraFilter;
    let referencia = this.referenciaFilter;
    let pedimento = this.pedimentoFilter;
    let ordenCompraFilter = this.ordenCompraModalFilter;
    let documentoContable = this.documentoContable;
    let tipoFactura = this.tipoFacturaFilter;
    let fechaI = (<HTMLInputElement>document.getElementById('fechaiOpt')).value;
    let fechaF = (<HTMLInputElement>document.getElementById('fechafOpt')).value;


    proveedor = (proveedor === undefined) ? '' : proveedor;
    sociedad = (sociedad === undefined) ? '' : sociedad;
    ordenCompra = (ordenCompra === undefined) ? '' : ordenCompra;
    referencia = (referencia === undefined) ? '' : referencia.replace(/\s+/g, '');
    if (tipoFactura === undefined) { tipoFactura = ''; }
    if (fechaI === undefined) { fechaI = ''; }
    if (fechaF === undefined) { fechaF = ''; }
    pedimento = (pedimento === undefined) ? '' : pedimento.replace(/\s+/g, '');
    ordenCompraFilter = (ordenCompraFilter === undefined) ? '' : ordenCompraFilter.replace(/\s+/g, '');
    documentoContable = (documentoContable === undefined) ? '' : documentoContable.replace(/\s+/g, '');


    if ((proveedor === '') && (sociedad === '') &&
      (ordenCompra === '') && (referencia === '') 
      && (tipoFactura === '') && (fechaI === '') && (fechaF === '') && (pedimento === '')
      && (ordenCompraFilter === '') && (documentoContable === '')) {
      this.flagBusqueda = false;
      this.flagMensaje = true;
    } else {
      this.flagBusqueda = true;
      this.flagMensaje = false;
    }

    this.fechaAnterior = fechaI;
    this.fechaHoy = fechaF;
    if (this.flagBusqueda) {
      this.facturas = [];
      this.processInvoicesService.buscarFacturas(sociedad, proveedor, ordenCompra, fechaI,
        fechaF, '', tipoFactura, referencia, pedimento, ordenCompraFilter, documentoContable, this.user.id).subscribe(
          data => {
            this.busyBusqueda = false;
            this.masterFacturas = data.masterFactura; 

            if (data != null) {
              this.rows = [];
              for (let i = 0; i < this.masterFacturas.length; i++) {

                var datosTmp = [];
                if (this.masterFacturas[i].uuidComplementosRelacionados) {
                  if (typeof (this.masterFacturas[i].uuidComplementosRelacionados) == 'string') {
                    datosTmp.push(this.masterFacturas[i].uuidComplementosRelacionados);
                  } else if (typeof (this.masterFacturas[i].uuidComplementosRelacionados) == 'object') {
                    for (let j = 0; j < this.masterFacturas[i].uuidComplementosRelacionados.length; j++) {
                      datosTmp.push(this.masterFacturas[i].uuidComplementosRelacionados[j]);
                    }
                  }
                }                

                var datos = {
                  aacategory: this.masterFacturas[i].aacategory,
                  cabecera: this.masterFacturas[i].cabecera,
                  claseDeDocumento: this.masterFacturas[i].claseDeDocumento,
                  docVim: this.masterFacturas[i].docVim,
                  estatus: this.masterFacturas[i].estatus,
                  fechaCarga: this.masterFacturas[i].fechaCarga,
                  fechaCont: this.masterFacturas[i].fechaCont,
                  fechaFact: this.masterFacturas[i].fechaFact,
                  importe: this.masterFacturas[i].importe,
                  indicadorIva: this.masterFacturas[i].indicadorIva,
                  iva: this.masterFacturas[i].iva,
                  moneda: this.masterFacturas[i].moneda,
                  nea: this.masterFacturas[i].nea,
                  nodocumento: this.masterFacturas[i].nodocumento,
                  operacion: this.masterFacturas[i].operacion,
                  ordencompra: this.masterFacturas[i].ordencompra,
                  paymentblock: this.masterFacturas[i].paymentblock,
                  pdf: this.masterFacturas[i].pdf,
                  proveedor: this.masterFacturas[i].proveedor,
                  referencia: this.masterFacturas[i].referencia,
                  requsito: this.masterFacturas[i].requisito,
                  sociedad: this.masterFacturas[i].sociedad,
                  texto: this.masterFacturas[i].texto,
                  textoCabecera: this.masterFacturas[i].textoCabecera,
                  tipo: this.masterFacturas[i].tipo,
                  uuid: this.masterFacturas[i].uuid,
                  uuidComplementosRelacionados: datosTmp,
                  xml: this.masterFacturas[i].xml,
                  totalNota: this.masterFacturas[i].totalNota,
                  uuidNota: this.masterFacturas[i].uuidNota,
                  rutaPdfNota: this.masterFacturas[i].rutaPdfNota,
                  rutaXmlNota: this.masterFacturas[i].rutaXmlNota,
                  rutaZIP: this.masterFacturas[i].zip,
                  docContable: this.masterFacturas[i].docContable ? this.masterFacturas[i].docContable : '--',
                  cuentaAgente: this.masterFacturas[i].cuentaAgente ? this.masterFacturas[i].cuentaAgente : '--',
                  pedimento: this.masterFacturas[i].pedimento ? this.masterFacturas[i].pedimento : '--'
                }
                this.facturas.push(datos);
              }
              //  this.rows = this.facturas;
              //  this.masterFacturas = data.masterFactura;
              this.numFacturasProcesadas = this.masterFacturas.length;
              if (this.masterFacturas.length > 0) {
                this.mostrarxml = true;
              } else {
                this.mostrarxml = false;
              }

              this.numFacturasProcesadas = this.masterFacturas.length;
              this.rows = [];
              this.rows = this.facturas; 
              this.modalFilters.close();
            }


          },
          err => {
            if (err.status === 401) {
              this.storageService.openLogout();
            }
          },
      );
    } else {
      this.busyBusqueda = false;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/process-invoices/process-invoices.component.ts